// Бездействие: нет мыши и клавиатуры дольше ms — onIdle (выход из присутствия); первое же
// движение после — onActive. Сброс таймера не чаще раза в секунду: pointermove идёт сотнями в секунду.
export type IdleTarget = Pick<EventTarget, 'addEventListener' | 'removeEventListener'>;

const EVENTS = ['pointermove', 'pointerdown', 'keydown', 'wheel'] as const;
const RESET_EVERY_MS = 1000;

export function watchIdle(target: IdleTarget, ms: number, onIdle: () => void, onActive: () => void): () => void {
  let timer: ReturnType<typeof setTimeout> | null = null;
  let idle = false;
  let lastReset = 0;
  const arm = () => { timer = setTimeout(() => { idle = true; onIdle(); }, ms); };
  const onEvent = () => {
    const now = Date.now();
    if (idle) { idle = false; onActive(); }
    else if (now - lastReset < RESET_EVERY_MS) return;
    lastReset = now;
    if (timer) clearTimeout(timer);
    arm();
  };
  for (const e of EVENTS) target.addEventListener(e, onEvent, { passive: true });
  arm();
  return () => { if (timer) clearTimeout(timer); for (const e of EVENTS) target.removeEventListener(e, onEvent); };
}
